module.exports = __webpack_public_path__ + "img/Facebook.b04bec58.svg";